// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"cc47c609626f916e","6831":"8e893de177b30e17","8503":"d735be3094dbea83","9683":"6a036db6b0545e50"}[chunkId] + ".js";
};